import {Link} from "react-router";

export const ServiceNotAvailable = () => (
  <small>
    Sorry, this Check type is not available on your current subscription. Please{" "}
    <Link target="_blank" to="/contact">
      contact us
    </Link>{" "}
    or{" "}
    <Link target="_blank" to="/billing/manage-add-ons">
      upgrade
    </Link>{" "}
    to have your account limit increased.
  </small>
);
